import { safeStorage } from "@utils/safeStorage"
import { useEffect, useMemo, useState } from "react"

type NewsletterCookie = {
  subscribed: boolean
  dismissedAt?: number
}

/**
 * Stores/retrieves whether/when the user has signed up for the newsletter, or dismissed the newsletter popup.
 */
export function useNewsletterCookie() {
  const initial = useMemo(() => {
    if (env.client) {
      return read()
    } else {
      return {
        subscribed: false,
      }
    }
  }, [])

  const [state, setState] = useState<NewsletterCookie>(initial)

  useEffect(() => {
    return safeStorage.subscribe(["newsletter-dismissed-at", "newsletter-did-subscribe"], (e) => {
      setState(read())
    })
  }, [])

  return {
    ...state,
    setDismissed() {
      setState({ subscribed: false, dismissedAt: Date.now() })
      safeStorage.setItem("newsletter-dismissed-at", Date.now().toString())
    },
    setSubscribed() {
      setState({ subscribed: true, dismissedAt: undefined })
      safeStorage.setItem("newsletter-did-subscribe", "true")
      safeStorage.setItem("newsletter-dismissed-at", "")
    },
  }
}

function read(): NewsletterCookie {
  const hasSubscribed = safeStorage.getItem("newsletter-did-subscribe")
  const timestamp = safeStorage.getItem("newsletter-dismissed-at")
  return {
    subscribed: !!hasSubscribed,
    dismissedAt: timestamp ? parseInt(timestamp) : undefined,
  }
}
